module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"newNotificationCount":"{count} Yeni Bildirim","title":"Bildirimler"}}')
  delete Component.options._Ctor
}
